import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { put } from "@rails/request.js"

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = {
    parentId: Number,   // optional
    parentType: String, // optional
    url: String 
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 350,
      ghostClass: 'sortable-item-ghost',
      onEnd: this.onEnd.bind(this),
      handle: '[data-sortable-handle]',
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  _getPayload(e) {
    const { newIndex } = e;
    const newPosition = newIndex + 1

    if (this.hasParentIdValue && this.hasParentTypeValue) {
      console.log('parentId', this.parentIdValue)
      console.log('parentType', this.parentTypeValue)
      return { position: newPosition, parent_id: this.parentIdValue,  parent_type: this.parentTypeValue }
    }
    else {
      return { position: newPosition }
    }
  }

  onEnd(e) {
    console.log(e)
    const { item } = e;
    const url = item.dataset['sortableUrl']
    const payload = this._getPayload(e)

    put(url, {
      body: JSON.stringify(payload),
      contentType: 'application/json'
    }).catch(error => console.error('Error updating position:', error))
  }
}